import { useMutation, useQueryClient } from "@tanstack/react-query";

import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { readComplianceBody } from "../helper/readComplianceBody";
import type { FraudGlRuleApi } from "./useGetFraudRules";

type StoredToken = { AccessToken?: string };

/** PATCH /v1/fraud/rule — all fields optional; backend updates the single GLI rule. */
export type UpdateFraudRulePayload = {
  rule_name?: string;
  deposit_threshold?: number;
  evaluation_window_seconds?: number;
  active?: boolean;
};

const updateFraudRule = async (payload: UpdateFraudRulePayload): Promise<FraudGlRuleApi | undefined> => {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const PrivateAdminPanelInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  const response = await PrivateAdminPanelInstance.patch(API_ROUTES.FRAUD_RULE, payload);
  return readComplianceBody<FraudGlRuleApi>(response);
};

export const useUpdateFraudRule = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateFraudRule,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["GET_FRAUD_RULE"] });
    },
  });
};
